/**
 * Calculate age from date of birth
 * @param {string} dateOfBirth - Date of birth in YYYY-MM-DD format
 * @returns {object} - Object with value and unit (years, months, or days)
 */
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return { value: 0, unit: 'years' };
  
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  
  // Calculate difference in milliseconds
  const diffMs = today - birthDate;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
  // If less than 60 days, return in days
  if (diffDays < 60) {
    return { value: diffDays, unit: 'days' };
  }
  
  // If less than 24 months, return in months
  const diffMonths = Math.floor(diffDays / 30.44); // Average days per month
  if (diffMonths < 24) {
    return { value: diffMonths, unit: 'months' };
  }
  
  // Otherwise return in years
  let years = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    years--;
  }
  
  return { value: years, unit: 'years' };
};

/**
 * Format age for display
 * @param {object} age - Age object with value and unit
 * @returns {string} - Formatted age string
 */
export const formatAge = (age) => {
  if (!age || !age.value) return 'N/A';
  
  const { value, unit } = age;
  
  if (value === 1) {
    // Singular
    return `${value} ${unit.slice(0, -1)}`;
  }
  
  return `${value} ${unit}`;
};

/**
 * Calculate age from date of birth and return formatted string
 * @param {string} dateOfBirth - Date of birth in YYYY-MM-DD format
 * @returns {string} - Formatted age string
 */
export const getAgeString = (dateOfBirth) => {
  const age = calculateAge(dateOfBirth);
  return formatAge(age);
};

/**
 * Validate date of birth (must be in the past and not too old)
 * @param {string} dateOfBirth - Date of birth in YYYY-MM-DD format
 * @returns {boolean} - True if valid
 */
export const isValidDateOfBirth = (dateOfBirth) => {
  if (!dateOfBirth) return false;
  
  const birthDate = new Date(dateOfBirth);
  const today = new Date();
  
  // Must be in the past
  if (birthDate >= today) return false;
  
  // Must not be more than 18 years old (for children)
  const maxAge = new Date();
  maxAge.setFullYear(maxAge.getFullYear() - 18);
  
  if (birthDate < maxAge) return false;
  
  return true;
};






